import React, { memo } from "react";
import { List } from "@mui/material";

import { TermOptionsTab } from "js/jsx/src/classes/tab/termOptionsTab";
import DataGridBoilerplate from "../DataGridBoilerplate";
import DraggableExpandable from "../DraggableExpandable/DraggableExpandableComponent";
import DeleteModalComponent from "../modals/DeleteModal";
import MarginModalComponent from "../modals/MarginModal/MarginModalComponent";
import NewRecordModalComponent from "../modals/NewRecordModal";
import PriceSourceModalComponent from "../modals/PriceSourceModal";
import useTabsWrapperContainer from "./tabsWrapperContainer";

function TabsWrapperComponent({ expanded }) {
	const {
		contentGrid,
		duplicatedTabId,
		isEditable,
		loading,
		open,
		change,
		Tabs,
		deleteModalRef,
		marginModalRef,
		newRecordRef,
		priceSourceModalRef,
		updateOpenTab,
		setChange,
		setDuplicatedTabId,
		setLoading,
		handleDeleteTab,
		handleDeleteGridRow,
		handleMove,
		openCustomizeGrid
	} = useTabsWrapperContainer();

	return (
		<div>
			<List>
				{Tabs.map((tab) => {
					return (tab?.IsHidden && !quosal.util.userIsAdminOrMaintainer()) ? null : (
						
					<DraggableExpandable
						key={`${tab.IdQuoteTabs}-key`}
						id={tab.IdQuoteTabs}
						tabItem={tab}
						open={open}
						duplicatedTabId={duplicatedTabId}
						openCustomizeGrid={openCustomizeGrid}
						onRemove={handleDeleteTab}
						onMove={handleMove}
						updateOpenTab={updateOpenTab}
						setChange={() => setChange(!change)}
						setDuplicatedTabId={setDuplicatedTabId}
						expanded={expanded}
						setLoading={setLoading}
						content={
							tab.TabName !== "Term Options" ? (
								<DataGridBoilerplate
									tabItem={tab}
									loading={loading}
									openCustomizeGrid={openCustomizeGrid}
									expanded={expanded}
									setChange={() => setChange(!change)}
									setLoading={setLoading}
									onRemove={handleDeleteGridRow}
									marginModalRef={marginModalRef}
									newRecordRef={newRecordRef}
									priceSourceModalRef={priceSourceModalRef}
								/>
							) : (
								<TermOptionsTab
									contentGrid={contentGrid}
									editable={
										isEditable &&
										(!tab.IsProtectedTab ||
											contentGrid.state.userCanModifyProtectedTab)
									}
									tab={tab}
								/>
							)
						}
					/>
				)}
			)}				
				{[
					<DraggableExpandable
						id=""
						key="add-new-section"
						updateOpenTab={updateOpenTab}
						setChange={() => setChange(!change)}
					/>
				]}
			</List>
			<DeleteModalComponent ref={deleteModalRef} />
			<MarginModalComponent ref={marginModalRef} />
			<NewRecordModalComponent ref={newRecordRef} />
			<PriceSourceModalComponent ref={priceSourceModalRef} />
		</div>
	);
}
export default memo(TabsWrapperComponent);
